import { render, staticRenderFns } from "./RowHeading.vue?vue&type=template&id=9d43d202&scoped=true"
import script from "./RowHeading.vue?vue&type=script&lang=js"
export * from "./RowHeading.vue?vue&type=script&lang=js"
import style0 from "./RowHeading.vue?vue&type=style&index=0&id=9d43d202&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d43d202",
  null
  
)

export default component.exports